import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import { BsCalendar2 } from "react-icons/bs";
import PhoneInput from "react-phone-input-2";
import Select from "react-select";
import "react-phone-input-2/lib/bootstrap.css";
import "react-datepicker/dist/react-datepicker.css";
import { useLanguage } from "../../contextApi/languageContext";
import tabbyImages from "../../../assets/tabbytamara.png";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import axios from "axios";
import API_URL from "../../../config";
import { FiGift, FiStar } from "react-icons/fi";
import CountUp from "react-countup";
import { useNavigate } from "react-router-dom";

const MultiStepForm = () => {
  const [step, setStep] = useState(1);
  const [showPopup, setShowPopup] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [options, setOptions] = useState([]);
  const [arabicOptions, setArabicOptions] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  // const [showRedeemModal, setShowRedeemModal] = useState(true);
  const { language } = useLanguage();
  const navigate = useNavigate();

  const extractLeafSubservices = (nodes) => {
    let result = [];
    for (const node of nodes) {
      const hasChildren =
        Array.isArray(node.children) && node.children.length > 0;
      if (node.name && !hasChildren) {
        result.push({
          label: node.name,
          value: node.name.toLowerCase().replace(/\s+/g, "_"),
        });
      }
      if (hasChildren) {
        result = result.concat(extractLeafSubservices(node.children));
      }
    }
    return result;
  };

  const extractArabicSubservices = (nodes) => {
    let result = [];
    for (const node of nodes) {
      const hasChildren =
        Array.isArray(node.children) && node.children.length > 0;

      if (node.arabic_name && !hasChildren) {
        result.push({
          label: node.arabic_name,
          value: node.name.toLowerCase().replace(/\s+/g, "_"),
        });
      }
      if (hasChildren) {
        result = result.concat(extractArabicSubservices(node.children));
      }
    }

    return result;
  };

  useEffect(() => {
    axios
      .get(`${API_URL}/layout/header`)
      .then((response) => {
        const submenu = response.data?.Submenu || [];

        const formattedOptions = extractLeafSubservices(submenu);
        const arabicFormattedOptions = extractArabicSubservices(submenu);
        setOptions(formattedOptions);
        setArabicOptions(arabicFormattedOptions);
      })
      .catch((error) => {
        console.error("Error fetching subservices:", error);
      });
  }, []);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    email: "",
    phone: "",
    profession: "",
    wellnessGoals: [],
    appointmentDate: null,
    consent: false,
    interestin: "",
  });

  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    if (isMobile) {
      const timer = setTimeout(() => setShowPopup(true), 5000); // show after 5s
      return () => clearTimeout(timer);
    }
  }, []);

  const nextStep = () => setStep((prev) => prev + 1);
  const prevStep = () => setStep((prev) => prev - 1);

  const handleServiceChange = (selectedOptions) => {
    setSelectedServices(selectedOptions);
    setFormData({
      ...formData,
      interestin: selectedOptions.map((option) => option.label).join(", "),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const payload = {
      ...formData,
      pageUrl: window.location.href,
    };

    console.log("PAYLOAD", payload);

    try {
      const res = await axios.post(`${API_URL}/layout/send-mail`, payload);
      if (res.data.success) {
        toast.success("Thanks for connecting with us");
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          gender: "",
          profession: "",
          wellnessGoals: [],
          interestin: "",
          appointmentDate: null,
          consent: false,
          pageUrl: "",
        });
        setSelectedServices([]);
        // setShowRedeemModal(true);
      } else {
        toast.error("Please fill all the required fields");
      }
    } catch (error) {
      toast.error("Oops! It seems required fields are missing.");
    } finally {
      setIsSubmitting(false);
      // setShowRedeemModal(false);
    }
  };

  const filterTime = (time) => {
    const hour = time.getHours();
    // Disable times between 9PM (21) and 10AM (10)
    return hour >= 10 && hour < 21;
  };

  const FormContent = (
    <form
      onSubmit={handleSubmit}
      className="rounded-4 p-2 sm-p-4 shadow"
      style={{
        border: "2px solid #c69933",
        background: "#fbf5e5",
        maxWidth: "100%",
      }}
    >
      {/* Header */}
      <div
        className="p-2 mb-3 rounded-3 text-white text-center"
        style={{
          background: "linear-gradient(to right, #bdaa7d, #c69933)",
        }}
      >
        {language === "en" ? (
          <>
            <h2 className="h3 fw-bold">Fill in your details below</h2>
            <p className="text-light mt-1">
              Claim Your <span className="fw-bolder">30% Discount</span>
            </p>
          </>
        ) : (
          <>
            <h2 className="h3 fw-bold">املأ بياناتك أدناه</h2>
            <p className="text-light mt-1">
              خصم <span className="fw-bolder">%30</span>
            </p>
          </>
        )}
      </div>

      {/* Timeline Progress */}
      <div
        className="progress-timeline d-flex justify-content-between align-items-center my-2 px-2"
        style={{ marginLeft: "70px" }}
      >
        {[1, 2, 3].map((s, i) => (
          <div className="timeline-step" key={i}>
            <div className={`circle ${step >= s ? "active" : ""}`}></div>
            {s !== 3 && (
              <div className={`line ${step > s ? "active" : ""}`}></div>
            )}
          </div>
        ))}
      </div>

      {/* Step 1 */}
      {step === 1 && (
        <>
          <div className="mb-3">
            <label className="form-label">
              {language === "en" ? "First Name" : "الاسم الأول"}
            </label>
            <input
              type="text"
              className="form-control custom-input"
              required
              placeholder={
                language === "en" ? "Enter first name" : "أدخل الاسم الأول"
              }
              value={formData.firstName}
              onChange={(e) =>
                setFormData({ ...formData, firstName: e.target.value })
              }
            />
          </div>
          <div className="mb-3">
            <label className="form-label">
              {language === "en" ? "Last Name" : "الاسم الأخير"}
            </label>
            <input
              type="text"
              className="form-control custom-input"
              required
              placeholder={
                language === "en" ? "Enter last name" : "أدخل الاسم الأخير"
              }
              value={formData.lastName}
              onChange={(e) =>
                setFormData({ ...formData, lastName: e.target.value })
              }
            />
          </div>
          <div className="mb-4">
            <label className="form-label">
              {language === "en" ? "Gender" : "الجنس"}
            </label>
            <select
              className="form-select custom-input py-2"
              required
              value={formData.gender}
              onChange={(e) =>
                setFormData({ ...formData, gender: e.target.value })
              }
            >
              <option value="">
                {language === "en" ? "Select Gender" : "اختر الجنس"}
              </option>
              <option value="male">{language === "en" ? "Male" : "ذكر"}</option>
              <option value="female">
                {language === "en" ? "Female" : "أنثى"}
              </option>
              <option value="other">
                {language === "en" ? "Other" : "آخر"}
              </option>
              <option value="prefer_not_say">
                {language === "en" ? "Prefer not to say" : "أفضل عدم الإجابة"}
              </option>
            </select>
          </div>
          <div className="d-flex justify-content-end">
            <button
              type="button"
              className="px-3 py-1 rounded"
              onClick={nextStep}
              style={{
                backgroundColor: "#bdaa7d",
                border: "2px solid #c69933",
              }}
            >
              <i className="fa-solid fa-arrow-right"></i>
            </button>
          </div>
        </>
      )}

      {/* Step 2 */}
      {step === 2 && (
        <>
          <div className="mb-3">
            <label className="form-label">
              {language === "en" ? "Email" : "البريد الإلكتروني"}
            </label>
            <input
              type="email"
              className="form-control custom-input"
              required
              placeholder={
                language === "en" ? "Enter email" : "أدخل البريد الإلكتروني"
              }
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
            />
          </div>
          <div className="mb-3">
            <label className="form-label">
              {language === "en" ? "Phone Number" : "رقم الهاتف"}
            </label>
            <div dir="ltr">
              {" "}
              {/* Force LTR layout for the phone input container */}
              <PhoneInput
                international
                country={language === "en" ? "ae" : "ae"} // UAE for English, Saudi for Arabic as example
                defaultCountry="ae"
                enableSearch
                value={formData.phone}
                onChange={(phone) => setFormData({ ...formData, phone })}
                inputStyle={{
                  width: "100%",
                  height: "50px",
                  paddingLeft: language === "en" ? "60px" : "15px",
                  paddingRight: language === "en" ? "15px" : "60px",
                  borderRadius: "0.375rem",
                  border: "1px solid #c69933",
                  textAlign: language === "en" ? "left" : "right",
                  direction: "ltr", // Force LTR for input text
                }}
                containerStyle={{
                  width: "100%",
                  direction: "ltr", // Force LTR container
                }}
                buttonStyle={{
                  border: "none",
                  [language === "en" ? "left" : "right"]: 0, // Position flag on correct side
                }}
                dropdownStyle={{
                  textAlign: language === "en" ? "left" : "right",
                }}
                searchPlaceholder={language === "en" ? "Search..." : "ابحث..."}
              />
            </div>
          </div>
          <div className="mb-4">
            <label className="form-label">
              {language === "en" ? "Profession" : "المهنة"}
            </label>
            <input
              type="text"
              className="form-control custom-input"
              placeholder={
                language === "en" ? "Enter profession" : "أدخل المهنة"
              }
              value={formData.profession}
              onChange={(e) =>
                setFormData({ ...formData, profession: e.target.value })
              }
            />
          </div>
          <div className="d-flex justify-content-between">
            <button
              type="button"
              className="px-3 py-1 rounded"
              onClick={prevStep}
              style={{
                backgroundColor: "#bdaa7d",
                border: "2px solid #c69933",
              }}
            >
              <i className="fa-solid fa-arrow-left"></i>
            </button>
            <button
              type="button"
              className="px-3 py-1 rounded"
              onClick={nextStep}
              style={{
                backgroundColor: "#bdaa7d",
                border: "2px solid #c69933",
              }}
            >
              <i className="fa-solid fa-arrow-right"></i>
            </button>
          </div>
        </>
      )}

      {/* Step 3 */}
      {step === 3 && (
        <>
          <div style={{ position: "relative", zIndex: 1000 }}>
            <div className="mb-4 mt-4">
              <label className="form-label mb-2">
                {language === "en"
                  ? "Interested Services"
                  : "الخدمات المهتم بها"}
              </label>
              <Select
                isMulti
                options={language === "en" ? options : arabicOptions}
                value={selectedServices}
                onChange={handleServiceChange}
                placeholder={
                  language === "en"
                    ? "Search and select services..."
                    : "ابحث واختر الخدمات..."
                }
                className="basic-multi-select"
                classNamePrefix="select"
                styles={{
                  control: (base) => ({
                    ...base,
                    border: "1px solid #c69933",
                    boxShadow: "none",
                    "&:hover": {
                      border: "1px solid #c69933",
                    },
                  }),
                  multiValue: (base) => ({
                    ...base,
                    backgroundColor: "#f0e6d2",
                  }),
                  multiValueLabel: (base) => ({
                    ...base,
                    color: "#5a4a2a",
                  }),
                }}
              />
            </div>
          </div>

          <div className="mb-3 position-relative" style={{ zIndex: 0 }}>
            <BsCalendar2
              className="position-absolute"
              style={{
                top: "50%",
                left: "15px",
                transform: "translateY(-50%)",
                color: "#c69933",
                zIndex: 1,
              }}
            />
            <DatePicker
              selected={formData.appointmentDate}
              onChange={(date) =>
                setFormData({ ...formData, appointmentDate: date })
              }
              minDate={new Date().setHours(10, 0, 0, 0)}
              placeholderText={
                language === "en" ? "Select Date & Time" : "اختر التاريخ والوقت"
              }
              className="form-control w-100 ps-5"
              wrapperClassName="w-100"
              showTimeSelect
              filterTime={filterTime}
              dateFormat="Pp"
            />
          </div>
          <div className="text-center ">
            <img
              src={tabbyImages}
              alt="tabbyimage"
              style={{ maxWidth: "200px", height: "auto" }}
              className="img-fluid"
            />
          </div>

          <div className="d-flex justify-content-between">
            <button
              type="button"
              className="px-3 py-1 rounded"
              onClick={prevStep}
              style={{
                backgroundColor: "#bdaa7d",
                border: "2px solid #c69933",
              }}
            >
              <i className="fa-solid fa-arrow-left"></i>
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-3 py-1 rounded text-white"
              style={{
                backgroundColor: isSubmitting ? "#ccc" : "#bdaa7d",
                border: "2px solid #c69933",
                minWidth: "190px",
                cursor: isSubmitting ? "not-allowed" : "pointer",
              }}
            >
              {isSubmitting
                ? language === "en"
                  ? "Submitting..."
                  : "جاري الإرسال..."
                : language === "en"
                ? "Book Now"
                : "احجز الآن"}
            </button>
          </div>
        </>
      )}
    </form>
  );

  return (
    <>
      {/* Desktop Right Sticky Form */}
      <div
        className="mx-0 d-none d-md-block rightColumnStyle"
        style={{ width: "30%" }}
      >
        <div className="" style={{ top: "12rem" }}>
          {FormContent}
        </div>
      </div>

      {/* Mobile Popup */}
      {showPopup && (
        <div
          className="d-md-none position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1050,
            width: "100%",
          }}
        >
          <div
            className="bg-white rounded-4 p-1 shadow mx-auto"
            style={{ width: "90%", maxHeight: "90vh" }}
          >
            <button
              className="btn-close position-absolute top-0 end-0 m-3"
              onClick={() => setShowPopup(false)}
            ></button>
            {FormContent}
          </div>
        </div>
      )}

      {/* Success Modal */}
      {/* {showRedeemModal && (
        <div
          className="d-flex position-fixed top-0 start-0 w-100 h-100 justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            zIndex: 1060,
            backdropFilter: "blur(3px)",
          }}
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: "spring", damping: 20 }}
            className="bg-white rounded-4 p-4 shadow-lg position-relative"
            style={{ width: "90%", maxWidth: "500px" }}
          >
          
            <button
              className="btn-close position-absolute top-0 end-0 m-3"
              onClick={() => setShowRedeemModal(false)}
            ></button>

        
            <div className="text-center py-4">
           
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.2 }}
                className="mx-auto mb-4 d-flex align-items-center justify-content-center"
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #4ade80, #22c55e)",
                }}
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="3"
                >
                  <motion.path
                    d="M5 13l4 4L19 7"
                    initial={{ pathLength: 0 }}
                    animate={{ pathLength: 1 }}
                    transition={{ duration: 0.5, delay: 0.3 }}
                  />
                </svg>
              </motion.div>

              <h3 className="fw-bold mb-3">Booking Confirmed!</h3>

             
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
                className="d-flex align-items-center justify-content-center gap-2 mb-4 p-3 rounded-3"
                style={{ background: "rgba(234, 179, 8, 0.1)" }}
              >
                <div className="points-badge bg-warning text-white rounded-pill px-3 py-1 d-flex align-items-center">
                  <FiStar className="me-1" />
                  <CountUp end={10} duration={1.5} className="fw-bold" />
                  <span className="ms-1">Points Earned!</span>
                </div>
              </motion.div>

              <p className="mb-4">
                Thank you for your booking! You've earned{" "}
                <strong>10 reward points</strong>. Keep going to unlock more
                benefits!
              </p>

          
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.8 }}
                className="referral-card p-3 mb-3 rounded-3"
                style={{
                  background: "linear-gradient(135deg, #f3f4f6, #e5e7eb)",
                }}
              >
                <div className="d-flex align-items-center gap-3">
                  <div className="icon-circle bg-primary text-white">
                    <FiGift size={24} />
                  </div>
                  <div>
                    <h6 className="mb-1 fw-bold">Refer Friends & Earn More</h6>
                    <small className="text-muted">
                      Get 50 points for each successful referral
                    </small>
                  </div>
                </div>
                <button
                  className="btn btn-primary mt-3 w-100 py-2"
               
                >
                  Invite Friends Now
                </button>
              </motion.div>

           

              <button
                className=" w-100 mt-4 py-2"
                onClick={ () => navigate("/wallet")}
              >
                View My Rewards
              </button>
            </div>
          </motion.div>
        </div>
      )} */}

      {/* Styles */}
      <style>{`
        .btn-arrow {
          background-color: #c69933;
          border: none;
          width: 48px;
          height: 48px;
          border-radius: 50%;
          font-size: 1.5rem;
          transition: background-color 0.3s ease, transform 0.2s ease;
          box-shadow: 0 4px 10px rgba(0,0,0,0.1);
        }

        .btn-arrow:hover {
          background-color: #b38a2e;
          transform: scale(1.05);
        }

        .custom-input:focus {
          border-color: #c69933 !important;
          box-shadow: none !important;
        }

        .timeline-step {
          display: flex;
          align-items: center;
          flex: 1;
        }

        .timeline-step .circle {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: #d1d1d1;
        }

        .timeline-step .circle.active {
          background: #c69933;
        }

        .timeline-step .line {
          flex: 1;
          height: 3px;
          background: #d1d1d1;
          margin: 0 4px;
        }

        .timeline-step .line.active {
          background: #c69933;
        }

        .btn-check:checked + .btn-outline-warning {
          background-color: #c69933;
          color: #fff;
          border-color: #c69933;
          box-shadow: 0 0 5px rgba(198, 153, 51, 0.5);
        }

        /* Animation classes */
@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

.points-badge {
  animation: pulse 1.5s infinite;
}

.icon-circle {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.referral-card {
  transition: all 0.3s ease;
  border: 1px solid rgba(0,0,0,0.05);
}

.referral-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}
      `}</style>
    </>
  );
};

export default MultiStepForm;
